import { useNotificationContext } from "../context/NotificationContext";

/**
 * Convenience hook for in-app notifications (API + socket-backed).
 */
export default function useNotifications() {
  return useNotificationContext();
}

export { useNotifications };
